import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router";
import Navigation from "../components/nav";
import * as paths from "./paths";
import ScrollToTop from "./ScrollToTop";
import Landing from "../components/landing";
import Login from "../components/login";
import Account from "../components/dashboard";
import { DeviceDashboard } from "../components/devicedashboard";
import AlarmHistory from "../components/alarmhistory";
import PrivacyPage from "../components/privacy";
import { ForgotPassword } from "../components/forgotpassword";
import Settings from "../components/settings";
import { AlarmHistorySummary } from "../components/alarmhistorysummary";
import { Management } from "../components/management";
import { NewAccount } from "../components/newAccount";
import { UptimeHistory } from "../components/uptimehistory";
import { MetricsDashboard } from "../components/uptimehistory/MetricsDashboard";
import { TrafficMetrics } from "../components/uptimehistory/TrafficMetrics";
import { UpdateLogs } from "../components/updatelogs";
import { ForcedChangePassword } from "../components/changepassword";
import DesktopOnly from "../components/utility/DesktopOnly";
// import { NotifyGroup } from "../tests/NotifyGroup";
// import { FilterTest } from "../tests/FilterTest";

const AppRoutes = () => {
  const loggedIn = !!useSelector(state => state.app.auth.token)
  const profile = useSelector(state => state.app.profile)
  const isAdmin = !!(profile && (profile.is_staff || profile.is_superuser || profile.role === 'special'))
  // An admin-assigned password flags the account; block every authenticated route and
  // force the change-password screen until the user picks their own (backend clears it).
  const mustChange = loggedIn && !!(profile && profile.must_change_password)

  const element = (reactElement, loggedIn) => {
    if (!loggedIn) return <Navigate to={paths.LOGIN_PAGE} replace />
    if (mustChange) return <Navigate to={paths.CHANGE_PASSWORD_PAGE} replace />
    return reactElement
  }

  // Admin-only (system admins) routes: redirect non-admins away.
  const adminElement = (reactElement) => {
    if (!loggedIn) return <Navigate to={paths.LOGIN_PAGE} replace />
    if (mustChange) return <Navigate to={paths.CHANGE_PASSWORD_PAGE} replace />
    return isAdmin ? reactElement : <Navigate to={paths.ACCOUNT_PAGE} replace />
  }

  return (
    <Router>
      <ScrollToTop />
      <Navigation>
        <Routes>
          <Route exact path={paths.HOME_PAGE} element={<Landing />} />
          <Route exact path={paths.LOGIN_PAGE} element={<Login />} />
          <Route exact path={paths.ACCOUNT_PAGE} element={element(<Account />, loggedIn)} />
          {/* Not gated by mustChange (it IS the destination) — only requires login. */}
          <Route exact path={paths.CHANGE_PASSWORD_PAGE} element={loggedIn ? <ForcedChangePassword /> : <Navigate to={paths.LOGIN_PAGE} replace />} />
          <Route exact path={paths.DEVICES_DASHBOARD} element={element(<DesktopOnly pageName="RAD Dashboard"><DeviceDashboard /></DesktopOnly>, loggedIn)} />
          <Route exact path={paths.ALARM_HISTORY} element={element(<AlarmHistory />, loggedIn)} />
          <Route exact path={paths.ALARM_HISTORY_SUMMARY} element={element(<AlarmHistorySummary />, loggedIn)} />
          {/* <Route exact path={paths.UPTIME_HISTORY} element={<UptimeHistory />} /> */}
          {/* <Route exact path={paths.UPTIME_HISTORY} element={element(<MetricsDashboard />, loggedIn)} /> */}
          <Route exact path={paths.UPTIME_HISTORY} element={element(<TrafficMetrics />, loggedIn)} />
          <Route exact path={paths.PRIVACY_PAGE} element={<PrivacyPage />} />
          <Route exact path={paths.PASSWORD_RESET_REQUEST} element={<ForgotPassword />} />
          <Route exact path={paths.PASSWORD_RESET_PAGE} element={<ForgotPassword />} />
          <Route exact path={paths.SETTINGS_PAGE} element={element(<Settings />, loggedIn)} />
          <Route exact path={paths.MANAGEMENT_PAGE} element={element(<DesktopOnly pageName="Management"><Management /></DesktopOnly>, loggedIn)} />
          <Route exact path={paths.UPDATE_LOGS} element={adminElement(<UpdateLogs />)} />
          <Route exact path={paths.NEW_ACCOUNT_PAGE} element={<NewAccount />} />
          {/* <Route exact path={TEST_PAGE} element={<FilterTest />} /> */}
        </Routes>
      </Navigation>
    </Router>
  );
};

export default AppRoutes;
